<template>
    <md-cell-item :title="name" :brief="ctime" arrow @click="show_children" class="news">
        <p slot="children" class="new-content" v-if="showchildren" v-html="content"></p>
        <span slot="right">More</span>
    </md-cell-item>
</template>
  
<script>
import { getnewsIddetail } from '@/request/api'
export default {
    name: 'newitem',
    props: {
        name: {
            type: String,
            default: "News name"
        },
        id: {
            type: Number,
            default: 0
        },
        ctime: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            showchildren: false,
            content: "",
        }
    },
    methods: {
        show_children() {
            this.$router.push("/newdetail/" + this.id);
            return;
            if (this.showchildren) {
                this.showchildren = !this.showchildren;
            } else {
                this.$toast.loading();
                getnewsIddetail(this.id).then(res => {
                    this.$toast.hide();
                    if (res.code === 200) {
                        this.content = res.data.content;
                        this.showchildren = !this.showchildren;
                    }
                });
            }
        }
    }
}

</script>
<style scoped>
.news>>>.md-cell-item-children {
    text-align: center;
}

.new-content {
    width: 6rem;
    padding: 0.1rem 0 0.1rem 0;
    word-wrap: break-word;
    font-size: 0.24rem;
    color: #858B9C;
}
</style>



// WEBPACK FOOTER //
// src/components/newitem.vue